// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5561ff99","884":"fa9d5a50"}[chunkId] + ".chunk.js";
};